import React from "react";
import Quiz from "../Quiz";

const questions = [
  {
    questionText: "All things can be categorized into two main groups called …",
    options: ["Animals and plants", "Living and non-living", "Air and land", "Food and water"],
    correct: "Living and non-living",
  },
  {
    questionText: "Which of the following are examples of living things in an ecosystem?",
    options: ["Plants and animals", "Air, sunlight and temperature", "Rocks and minerals", "Lakes and oceans"],
    correct: "Plants and animals",
  },
  {
    questionText: "What is the difference between living and non-living things?",
    options: ["Living things are bigger", "Living things are smaller", "Living things can move and grow", "Non-living are heavier"],
    correct: "Living things can move and grow",
  },
  {
    questionText: "Which one of the following is NOT a life process?",
    options: ["Respiration", "Fertilisation", "Excretion", "Reproduction"],
    correct: "Fertilisation",
  },
  {
    questionText: "What do living things need to grow?",
    options: ["Food, water, air", "Food, shelter, love", "Water, shelter, air", "Food, water, sunlight"],
    correct: "Food, water, sunlight",
  },
  {
    questionText: "What is the process called when living things increase in size and develop new parts?",
    options: ["Growth", "Reproduction", "Respiration", "Excretion"],
    correct: "Growth",
  },
  {
    questionText: "What are the requirements for photosynthesis?",
    options: ["Water, sunlight and air", "Water, soil and fertilizer", "Sunlight, air and warmth", "Sunlight, water and carbon dioxide"],
    correct: "Sunlight, water and carbon dioxide",
  },
  {
    questionText: "What is the main function of a flower in a plant’s life cycle?",
    options: ["To make food for the plants", "To hold the plant upright", "To absorb water and nutrients", "To produce seeds"],
    correct: "To produce seeds",
  },
  {
    questionText: "Which part of a plant makes food for the plant?",
    options: ["Roots", "Flowers", "Leaves", "Stems"],
    correct: "Leaves",
  },
  {
    questionText: "Which part of the plant anchors it in the soil and absorbs water?",
    options: ["Leaves", "Flowers", "Roots", "Stems"],
    correct: "Roots",
  },
  {
    questionText: "What part of the plant carries water and nutrients from roots to other parts?",
    options: ["Leaves", "Stem", "Fruit", "Flower"],
    correct: "Stem",
  },
  {
    questionText: "What is the function of the fruit in a plant?",
    options: ["To store seeds", "To make food", "To absorb water", "To provide shelter"],
    correct: "To store seeds",
  },
  {
    questionText: "What is the main function of a skeleton in animals?",
    options: ["To protect internal organs", "To regulate body temperature", "To provide growth", "To produce energy"],
    correct: "To protect internal organs",
  },
  {
    questionText: "What is the main difference between invertebrates and vertebrates?",
    options: ["Body size", "Number of legs", "Presence or absence of a backbone", "Type of skin"],
    correct: "Presence or absence of a backbone",
  },
  {
    questionText: "Which group of animals includes humans, dogs and cats?",
    options: ["Invertebrates", "Vertebrates", "Mammals", "Reptiles"],
    correct: "Vertebrates",
  },
  {
    questionText: "Which of the following is an example of a vertebrate animal?",
    options: ["Octopus", "Snail", "Fish", "Tapeworm"],
    correct: "Fish",
  },
  {
    questionText: "Which of the following is an example of an invertebrate animal?",
    options: ["Snake", "Fish", "Dog", "Earthworm"],
    correct: "Earthworm",
  },
  {
    questionText: "Which of the following is a characteristic of invertebrates?",
    options: ["Presence of a backbone", "Absence of a backbone", "Presence of internal skeleton", "Absence of internal skeleton"],
    correct: "Absence of a backbone",
  },
  {
    questionText: "What is an ecosystem?",
    options: [
      "A place where only plants live",
      "A group of living and non-living things interacting",
      "A forest only",
      "An animal habitat only"
    ],
    correct: "A group of living and non-living things interacting",
  },
  {
    questionText: "Which of these is NOT a non-living component of an ecosystem?",
    options: ["Sunlight", "Water", "Air", "Plant"],
    correct: "Plant",
  },
  {
    questionText: "Why are decomposers important in an ecosystem?",
    options: [
      "They produce oxygen",
      "They recycle nutrients back to the soil",
      "They eat plants",
      "They provide shade"
    ],
    correct: "They recycle nutrients back to the soil",
  },
  {
    questionText: "Which of these is a producer in a food chain?",
    options: ["Lion", "Grass", "Rabbit", "Fungi"],
    correct: "Grass",
  },
  {
    questionText: "Which of the following is an example of a carnivore?",
    options: ["Cow", "Sheep", "Leopard", "Grasshopper"],
    correct: "Leopard",
  },
  {
    questionText: "Which is the correct order in a basic food chain?",
    options: [
      "Consumer → Producer → Decomposer",
      "Producer → Consumer → Decomposer",
      "Decomposer → Consumer → Producer",
      "Consumer → Decomposer → Producer"
    ],
    correct: "Producer → Consumer → Decomposer",
  },
  {
    questionText: "Which part of the food chain makes its own food using sunlight?",
    options: ["Consumers", "Predators", "Producers", "Herbivores"],
    correct: "Producers",
  },
];

export default function NaturalScienceQuiz8({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete} />;
}
